// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"O3-z","colorTextValue":"P3-z","swatches":"Q3-z","collapseLink":"R3-z","isCollapsed":"S3-z","dropdown":"T3-z","disabled":"U3-z"};